import { render } from "./ProcessItemAdminUser.vue?vue&type=template&id=1ce44626&scoped=true&ts=true"
import script from "./ProcessItemAdminUser.vue?vue&type=script&lang=ts"
export * from "./ProcessItemAdminUser.vue?vue&type=script&lang=ts"

import "./ProcessItemAdminUser.vue?vue&type=style&index=0&id=1ce44626&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ce44626"]])

export default __exports__